import React from "react"

import Layout from "../components/product-layout"
import SEO from "../components/seo"

export default function Terms() {
  return (
    <Layout>
      <SEO title="Terms and Conditions" />
      <div className="container" style={{color: "#fff", fontSize: "0.8em"}}>
      KACHING PRIVACY POLICY & CONDITIONS OF USE Updated: September 1st , 2020
      Please carefully read the Conditions of Use ,Privacy Policy and the
      Kaching Interest-Based Ads Policy (collectively, the “Agreement”) for the
      relevant websites for which Kaching is or will be configured by you (each
      an “Applicable Site”) . By clicking the “Install” button (if applicable),
      or by installing, activating, enabling, using, or otherwise accessing
      Kaching, you accept and agree to be bound by this Agreement. If you do not
      wish to be bound by this Agreement, do not click “Install” and do not
      install, activate, enable, use, or otherwise access Kaching 1. About
      Kaching Kaching is a suite of software applications that supplement your
      online shopping experience. Kaching (together with any updates or
      upgrades, "Kaching”) is offered by Kaching Shopsmart Private Limited (such
      entity, together with its affiliates, “Kaching”,“we”, “us” or “our”) when
      configured for use with www.kaching.store. You may also elect to
      reconfigure Kaching for another website at any time. By doing so, you
      agree to be bound by the conditions of use applicable to using Kaching
      with each Applicable Site. 2. Kaching Information Kaching knows that you
      care about how information about you is collected and processed, and we
      appreciate your trust that we will do so carefully and sensibly.
      Information collected through Kaching, including personally identifiable
      information, is subject to the relevant privacy policy for the Applicable
      Site and our Privacy Policy notice, which are incorporated and form a part
      of this Agreement. 3. Additional Provisions These Kaching Conditions of
      Use include the conditions of use, the privacy policy, and the
      interest-based ads policy for the Applicable Site. 4. Modification Kaching
      reserves the right to make changes to this Agreement at any time by
      posting the revised terms on the Applicable Site and/or notifying you of
      such changes via Kaching. PRIVACY POLICY What Personal Information About
      Customers Does Kaching Collect? We collect your personal information in
      order to provide and continually improve our products and services. Here
      are the types of personal information we collect: Information You Give Us:
      We receive and store any information you provide in relation to Kaching
      Services. You can choose not to provide certain information, but then you
      might not be able to take advantage of many of our Services. Automatic
      Information: We automatically collect and store certain types of
      information about your use of Shopping Services, including information
      about your interaction with content and services . Like many websites, we
      use "cookies" and other unique identifiers, and we obtain certain types of
      information when your web browser or device accesses shopping services and
      other content on other websites. For What Purposes Does Kaching Use Your
      Personal Information? We use your personal information to operate,
      provide, develop, and improve the products and services that we offer our
      customers. These purposes include: Recommendations and personalization. We
      use your personal information to recommend features, products, and
      services that might be of interest to you, identify your preferences, and
      personalize your experience with Shopping Services. Communicate with you.
      We use your personal information to communicate with you in relation to
      Kaching Services via different channels (e.g., by phone, e-mail, chat).
      Advertising. We use your personal information to display interest-based
      ads for features, products, and services that might be of interest to you.
      We do not use information that personally identifies you to display
      interest-based ads. To learn more, please read our Interest Based Ad
      notice . Fraud Prevention and Credit Risks. We use personal information to
      prevent and detect fraud and abuse in order to protect the security of our
      customers, Kaching, and others. We may also use scoring methods to assess
      and manage credit risks. What About Cookies and Other Identifiers? To
      enable our systems to recognize your browser or device and to provide and
      improve Kaching Services, we use cookies and other identifiers.
      Information We Collect When You Interact with Kaching: When you interact
      with Kaching, we connect shopping browsing information with your Kaching
      Account. In these cases, Kaching acts as an extension of the shopping
      experience and processes your personal information in accordance with the
      Privacy Notice Does Kaching Share Your Personal Information? Information
      about our customers is an important part of our business, and we are not
      in the business of selling our customers’ personal information to others.
      We share customers’ personal information only as described below that
      either are subject to this Privacy Notice or follow practices at least as
      protective as those described in this Privacy Notice. Transactions
      involving Third Parties: We make available to you services, products,
      applications, or skills provided by third parties for use on or through
      Kaching Services. For example, you can order products from third parties
      through our stores, download applications from third-party application
      providers from our App Store, Third-Party Service Providers: We employ
      other companies and individuals to perform functions on our behalf.
      Examples include fulfilling orders for products or services, delivering
      packages, sending postal mail and e-mail, removing repetitive information
      from customer lists, analyzing data, providing marketing assistance,
      providing search results and links (including paid listings and links),
      processing payments, transmitting content, scoring, assessing and managing
      credit risk, and providing customer service. These third-party service
      providers have access to personal information needed to perform their
      functions, but may not use it for other purposes. Business Transfers: As
      we continue to develop our business, we might sell or buy other businesses
      or services. In such transactions, customer information generally is one
      of the transferred business assets but remains subject to the promises
      made in any pre-existing Privacy Notice (unless, of course, the customer
      consents otherwise). Also, in the unlikely event that Kaching Shopsmart
      Private Limited or substantially all of its assets are acquired, customer
      information will of course be one of the transferred assets. Protection of
      Kaching and Others: We release accounts and other personal information
      when we believe release is appropriate to comply with the law; enforce or
      apply our Conditions of Use and other agreements; or protect the rights,
      property, or safety of Kaching, our users, or others. This includes
      exchanging information with other companies and organizations for fraud
      protection and credit risk reduction. Other than as set out above, you
      will receive notice when personal information about you might be shared
      with third parties, and you will have an opportunity to choose not to
      share the information. How Secure Is Information About Me? We design our
      systems with your security and privacy in mind. We work to protect the
      security of your personal information during transmission by using
      encryption protocols and software. We follow the Payment Card Industry
      Data Security Standard (PCI DSS) when handling credit card data. We
      maintain physical, electronic, and procedural safeguards in connection
      with the collection, storage, and disclosure of personal customer
      information. Our security procedures mean that we may occasionally request
      proof of identity before we disclose personal information to you. It is
      important for you to protect against unauthorized access to your password
      and to your computers, devices, and applications. Be sure to sign off when
      finished using a shared computer. What About Advertising? Third-Party
      Advertisers and Links to Other Websites: Kaching Services may include
      third-party advertising and links to other websites and apps. Third-party
      advertising partners may collect information about you when you interact
      with their content, advertising, and services. For more information about
      third-party advertising at Kaching, including interest-based ads, please
      read our Interest Based Ad policy . Use of Third-Party Advertising
      Services: We provide ad companies with information that allows them to
      serve you with more useful and relevant ads and to measure their
      effectiveness. We never share your name or other information that directly
      identifies you when we do this. Instead, we use an advertising identifier
      like a cookie or other device identifier. For example, if you have already
      downloaded one of our apps, we will share your advertising identifier and
      data about that event so that you will not be served an ad to download the
      app again. Some ad companies also use this information to serve you
      relevant ads from other advertisers. What Information Can I Access? You
      can access your information, including your name, address, payment
      options, profile information. What Choices Do I Have? If you have any
      questions as to how we collect and use your personal information, please
      contact our Customer Service . Many of our Kaching Services also include
      settings that provide you with options as to how your information is being
      used. As described above, you can choose not to provide certain
      information, but then you might not be able to take advantage of many of
      the Kaching Services. You can add or update certain information on pages
      such as those referenced in What Information Can I Access?. When you
      update information, we usually keep a copy of the prior version for our
      records. If you do not want to receive e-mail or other communications from
      us, please contact our Customer Service . If you don’t want to receive
      in-app notifications from us, please adjust your notification settings in
      the app or device. The Help feature on most browsers and devices will tell
      you how to prevent your browser or device from accepting new cookies or
      other identifiers, how to have the browser notify you when you receive a
      new cookie, or how to block cookies altogether. Because cookies and
      identifiers allow you to take advantage of some essential features of
      Kaching Services, we recommend that you leave them turned on. You will
      also be able to opt out of certain other types of data usage by updating
      your settings on the applicable website For most devices, these controls
      are located in the device's settings menu. If you have questions about how
      to change your device permissions on devices manufactured by third
      parties, we recommend you contact your mobile service carrier or your
      device manufacturer. In addition, to the extent required by applicable
      law, you may have the right to request access to or delete your personal
      data. If you wish to do any of these things, please contact Customer
      Service . Depending on your data choices, certain services may be limited
      or unavailable. Are Children Allowed to Use Kaching Services? If you are
      under 18, you may use Kaching Services only with the involvement of a
      parent or guardian. We do not knowingly collect personal information from
      children under the age of 13 without the consent of the child's parent or
      guardian. Conditions of Use, Notices, and Revisions If you choose to use
      Kaching Services, your use and any dispute over privacy is subject to this
      Notice and our Conditions of Use , including limitations on damages,
      resolution of disputes, and application of the law of the state of
      Maharashtra. If you have any concern about privacy at Kaching, please
      contact us with a thorough description, and we will try to resolve it. Our
      business changes constantly, and our Privacy Notice will change also. You
      should check our websites frequently to see recent changes. Unless stated
      otherwise, our current Privacy Notice applies to all information that we
      have about you and your account. We stand behind the promises we make,
      however, and will never materially change our policies and practices to
      make them less protective of customer information collected in the past
      without the consent of affected customers. Interest-Based Ads
      Interest-based ads are sometimes referred to as personalized or targeted
      ads. We show interest-based ads to display features, products, and
      services that might be of interest to you. In providing interest-based
      ads, we follow the Self-Regulatory Principles for Online Behavioral
      Advertising developed by the Digital Advertising Alliance (a coalition of
      marketing, online advertising, and consumer advocacy organizations). What
      sort of information do we use to show interest-based ads? To serve you
      interest-based ads, we use information such as your interactions with
      Shopping sites,Kaching platform, content, or services. We do not use
      information which on its own identifies you, such as name or e-mail
      address, to serve interest-based ads. As is common in the advertising
      industry, we use cookies, pixels, and other technologies (collectively,
      "cookies"), which enable us to understand the effectiveness of the
      interest-based ads we show you by measuring what ads are clicked or
      viewed, and to provide you with more useful and relevant ads. For example,
      if we know what ads are shown to your browser we can be careful not to
      show the same ads repeatedly. How do we work with third parties to show
      you interest-based ads? We work with third parties, such as advertisers,
      publishers, social media networks, search engines, ad serving companies,
      and advertising companies working on their behalf, to improve the
      relevance of ads we serve. In providing you interest-based ads we do not
      associate your interactions on unaffiliated sites with information which
      on its own identifies you, such as name or email address, and we do not
      provide any such information to advertisers or to third-party sites that
      display our interest-based ads. Advertisers and other third parties may
      assume that users who interact with or click on an interest-based ad or
      content are part of the group that the ad or content is directed towards
      (for example, users in a particular geographical area or users who
      purchased or browsed for classical music). Some third-parties may provide
      us pseudonymized information about you (such as demographic information or
      sites where you have been shown ads) from offline and online sources that
      we may use to provide you more relevant and useful advertising. Third
      party advertisers or advertising companies working on their behalf
      sometimes use cookies in the process of delivering content, including ads,
      directly to your browser or device, and they may automatically receive an
      IP address when this happens. They may also use cookies to measure the
      effectiveness of their ads, show you more relevant advertising content,
      and perform services on behalf of Kaching. Advertising Preferences Kaching
      offers you choices about receiving interest-based ads from us. You can
      choose not to receive interest-based ads from Kaching. You will still see
      ads but they will not be based on your interests. You can also generally
      opt out of receiving personalized ads from third party advertisers and ad
      networks who are members of the Network Advertising Initiative (NAI) or
      who follow the Digital Advertising Alliance’s Self-Regulatory Principles
      for Online Behavioral Advertising by visiting the opt out pages on the NAI
      website and DAA website. Conditions of Use Last updated: September 1, 2020
      By using Kaching Services, you agree to these conditions. Please read them
      carefully. ELECTRONIC COMMUNICATIONS When you use Kaching Services, or
      send e-mails, text messages, and other communications from your desktop or
      mobile device to us, you may be communicating with us electronically. You
      consent to receive communications from us electronically, such as e-mails,
      texts, mobile push notices, or notices and messages on this site or
      through the other Kaching Services, such as our Message Center, and you
      can retain copies of these communications for your records. You agree that
      all agreements, notices, disclosures, and other communications that we
      provide to you electronically satisfy any legal requirement that such
      communications be in writing. COPYRIGHT All content included in or made
      available through any Kaching Service, such as text, graphics, logos,
      button icons, images, audio clips, digital downloads, data compilations,
      and software is the property of Kaching or its content suppliers and
      protected by India and international copyright laws. The compilation of
      all content included in or made available through any Kaching Service is
      the exclusive property of Kaching Shopsmart Private Limited and protected by
      India and international LICENSE AND ACCESS Subject to your compliance with
      these Conditions of Use and any Service Terms, and your payment of any
      applicable fees, Kaching or its content providers grant you a limited,
      non-exclusive, non-transferable, non-sublicensable license to access and
      make personal and non-commercial use of the Kaching Services. This license
      does not include any resale or commercial use of any Kaching Service, or
      its contents; any collection and use of any product listings,
      descriptions, or prices; any derivative use of any Kaching Service or its
      contents; any downloading, copying, or other use of account information
      for the benefit of any third party; or any use of data mining, robots, or
      similar data gathering and extraction tools. All rights not expressly
      granted to you in these Conditions of Use or any Service Terms are
      reserved and retained by Kaching or its licensors, suppliers, publishers,
      rightsholders, or other content providers. No Kaching Service, nor any
      part of any Kaching Service, may be reproduced, duplicated, copied, sold,
      resold, visited, or otherwise exploited for any commercial purpose without
      express written consent of Kaching. You may not frame or utilize framing
      techniques to enclose any trademark, logo, or other proprietary
      information (including images, text, page layout, or form) of Kaching
      without express written consent. You may not use any meta tags or any
      other "hidden text" utilizing Kaching's name or trademarks without the
      express written consent of Kaching. You may not misuse the Kaching
      Services. You may use the Kaching Services only as permitted by law. The
      licenses granted by Kaching terminate if you do not comply with these
      Conditions of Use or any Service Terms. YOUR ACCOUNT You may need your own
      Kaching account to use certain Kaching Services, and you may be required
      to be logged in to the account and have a valid payment method associated
      with it. If there is a problem charging your selected payment method, we
      may charge any other valid payment method associated with your account.
      You are responsible for maintaining the confidentiality of your account
      and password and for restricting access to your account, and you agree to
      accept responsibility for all activities that occur under your account or
      password. If you are under 18, you may use the Kaching Services only with
      involvement of a parent or guardian. Parents and guardians may create
      profiles for teenagers in their Kaching Household. Alcohol listings on
      Kaching are intended for adults. You must be at least 21 years of age to
      purchase alcohol, or use any site functionality related to alcohol.
      Kaching reserves the right to refuse service, terminate accounts,
      terminate your rights to use Kaching Services, remove or edit content, or
      cancel orders in its sole discretion. REVIEWS, COMMENTS, COMMUNICATIONS,
      AND OTHER CONTENT You may post reviews, comments, photos, videos, and
      other content; send e-cards and other communications; and submit
      suggestions, ideas, comments, questions, or other information, so long as
      the content is not illegal, obscene, threatening, defamatory, invasive of
      privacy, infringing of intellectual property rights (including publicity
      rights), or otherwise injurious to third parties or objectionable, and
      does not consist of or contain software viruses, political campaigning,
      commercial solicitation, chain letters, mass mailings, or any form of
      "spam" or unsolicited commercial electronic messages. You may not use a
      false e-mail address, impersonate any person or entity, or otherwise
      mislead as to the origin of a card or other content. Kaching reserves the
      right (but not the obligation) to remove or edit such content, but does
      not regularly review posted content. If you do post content or submit
      material, and unless we indicate otherwise, you grant Kaching a
      nonexclusive, royalty-free, perpetual, irrevocable, and fully
      sublicensable right to use, reproduce, modify, adapt, publish, perform,
      translate, create derivative works from, distribute, and display such
      content throughout the world in any media. You grant Kaching and
      sublicensees the right to use the name that you submit in connection with
      such content, if they choose. You represent and warrant that you own or
      otherwise control all of the rights to the content that you post; that the
      content is accurate; that use of the content you supply does not violate
      this policy and will not cause injury to any person or entity; and that
      you will indemnify Kaching for all claims resulting from content you
      supply. Kaching has the right but not the obligation to monitor and edit
      or remove any activity or content. Kaching takes no responsibility and
      assumes no liability for any content posted by you or any third party.
      INTELLECTUAL PROPERTY COMPLAINTS Kaching respects the intellectual
      property of others. If you believe that your intellectual property rights
      are being infringed, please connect with our Customer Support RISK OF LOSS
      All purchases of physical items from Kaching are made pursuant to a
      shipment contract. This means that the risk of loss and title for such
      items pass to you upon our delivery to the carrier. PRODUCT DESCRIPTIONS
      Kaching attempts to be as accurate as possible. However, Kaching does not
      warrant that product descriptions or other content of any Kaching Service
      is accurate, complete, reliable, current, or error-free. If a product
      offered by Kaching itself is not as described, your sole remedy is to
      return it in unused condition. PRICING "List Price" means the suggested
      retail price of a product as provided by a manufacturer, supplier, or
      seller. We regularly check List Prices against prices recently found on
      Kaching and other retailers. Certain products may have a "Was Price"
      displayed, which is determined using recent price history of the product
      on Kaching. With respect to items sold by Kaching, we cannot confirm the
      price of an item until you order. Despite our best efforts, a small number
      of the items in our catalog may be mispriced. If the correct price of an
      item sold by Kaching is higher than our stated price, we will, at our
      discretion, either contact you for instructions before shipping or cancel
      your order and notify you of such cancellation. Other merchants may follow
      different policies in the event of a mispriced item. We generally do not
      charge your credit card until after your order has entered the shipping
      process or, for digital products, until we make the digital product
      available to you. APP PERMISSIONS When you use apps created by Kaching,
      you may grant certain permissions to us for your device. Most mobile
      devices provide you with information about these permissions. OTHER
      BUSINESSES Parties other than Kaching operate stores, provide services or
      software, or sell product lines through the Kaching Services. In addition,
      we provide links to the sites of affiliated companies and certain other
      businesses. If you purchase any of the products or services offered by
      these businesses or individuals, you are purchasing directly from those
      third parties, not from Kaching. We are not responsible for examining or
      evaluating, and we do not warrant, the offerings of any of these
      businesses or individuals (including the content of their Web sites).
      Kaching does not assume any responsibility or liability for the actions,
      product, and content of all these and any other third parties. You should
      carefully review their privacy statements and other conditions of use.
      DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY THE Kaching SERVICES
      AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) AND
      OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
      Kaching SERVICES ARE PROVIDED BY Kaching ON AN "AS IS" AND "AS AVAILABLE"
      BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING. Kaching MAKES NO
      REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE
      OPERATION OF THE Kaching SERVICES, OR THE INFORMATION, CONTENT, MATERIALS,
      PRODUCTS (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE
      MADE AVAILABLE TO YOU THROUGH THE Kaching SERVICES, UNLESS OTHERWISE
      SPECIFIED IN WRITING. YOU EXPRESSLY AGREE THAT YOUR USE OF THE Kaching
      SERVICES IS AT YOUR SOLE RISK. TO THE FULL EXTENT PERMISSIBLE BY LAW,
      Kaching DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT
      LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
      PARTICULAR PURPOSE. Kaching DOES NOT WARRANT THAT THE Kaching SERVICES,
      INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER
      SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE
      Kaching SERVICES, Kaching'S SERVERS OR ELECTRONIC COMMUNICATIONS SENT FROM
      Kaching ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. TO THE FULL
      EXTENT PERMISSIBLE BY LAW, Kaching WILL NOT BE LIABLE FOR ANY DAMAGES OF
      ANY KIND ARISING FROM THE USE OF ANY Kaching SERVICE, OR FROM ANY
      INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR OTHER
      SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH ANY
      Kaching SERVICE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT,
      INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE
      SPECIFIED IN WRITING. DISPUTES Any dispute or claim relating in any way to
      your use of any Kaching Service, or to any products or services sold or
      distributed by Kaching or through Kaching.store will be resolved by
      binding arbitration, rather than in court, except that you may assert
      claims in small claims court if your claims qualify. The Federal
      Arbitration Act and federal arbitration law apply to this agreement. There
      is no judge or jury in arbitration, and court review of an arbitration
      award is limited. However, an arbitrator can award on an individual basis
      the same damages and relief as a court (including injunctive and
      declaratory relief or statutory damages), and must follow the terms of
      these Conditions of Use as a court would. We each agree that any dispute
      resolution proceedings will be conducted only on an individual basis and
      not in a class, consolidated or representative action. If for any reason a
      claim proceeds in court rather than in arbitration we each waive any right
      to a jury trial. We also both agree that you or we may bring suit in court
      to enjoin infringement or other misuse of intellectual property rights.
      APPLICABLE LAW By using any Kaching Service, you agree that the laws
      defined by Indian Constitution, without regard to principles of conflict
      of laws, will govern these Conditions of Use and any dispute of any sort
      that might arise between you and Kaching. SITE POLICIES, MODIFICATION, AND
      SEVERABILITY Please review our other policies, such as our pricing policy,
      posted on this site. These policies also govern your use of Kaching
      Services. We reserve the right to make changes to our site, policies,
      Service Terms, and these Conditions of Use at any time. If any of these
      conditions shall be deemed invalid, void, or for any reason unenforceable,
      that condition shall be deemed severable and shall not affect the validity
      and enforceability of any remaining condition. OUR ADDRESS CTS 610 & 611
      Makwana Road, near Marol Metro Station Mumbai - 400059
      Maharashtra – India Email address: support@kaching.club
      https://www.kaching.club Communication with Company If you wish to correct
      or update any information you have provided, you may do so online, on the
      website itself. Alternatively, you may contact the Company to correct or
      update such information by sending an e-mail to: support@kaching.club. In
      the event of loss of access to the website, you may contact the Company by
      sending an e-mail to: support@kaching.club. In the event you wish to
      report a breach of the Privacy Policy, you may contact the designated
      Grievance Officer of the Company at: Kaching Shopsmart Private Limited CTS 610 & 611
      Makwana Road, near Marol Metro Station Mumbai - 400059
      Maharashtra – India Email address: support@kaching.club ADDITIONAL Kaching
      SOFTWARE TERMS The following terms (“Software Terms”) apply to any
      software (including any updates or upgrades to the software) and any
      related documentation we make available to you in connection with Kaching
      Services (the "Kaching Software"). Use of the Kaching Software. You may
      use Kaching Software solely for purposes of enabling you to use the
      Kaching Services as provided by Kaching, and as permitted by these
      Conditions of Use and any Service Terms. You may not incorporate any
      portion of the Kaching Software into other programs or compile any portion
      of it in combination with other programs, or otherwise copy (except to
      exercise rights granted in this section), modify, create derivative works
      of, distribute, assign any rights to, or license the Kaching Software in
      whole or in part. All software used in any Kaching Service is the property
      of Kaching or its software suppliers and is protected by United States and
      international copyright laws. Use of Third Party Services. When you use
      the Kaching Software, you may also be using the services of one or more
      third parties, such as a wireless carrier or a mobile software provider.
      Your use of these third party services may be subject to the separate
      policies, terms of use, and fees of these third parties. No Reverse
      Engineering. You may not reverse engineer, decompile or disassemble,
      tamper with, or bypass any security associated with the Kaching Software,
      whether in whole or in part. Updates. We may offer automatic or manual
      updates to the Kaching Software at any time and without notice to you.
      Conflicts. In the event of any conflict between these Conditions of Use
      and any other Kaching or third-party terms applicable to any portion of
      Kaching Software, such as open-source license terms, such other terms will
      control as to that portion of the Kaching Software and to the extent of
      the conflict.
      </div>
    </Layout>
  )
}
